import { render, staticRenderFns } from "./AddMetricSideSheet.vue?vue&type=template&id=45376d38&scoped=true"
import script from "./AddMetricSideSheet.vue?vue&type=script&lang=js"
export * from "./AddMetricSideSheet.vue?vue&type=script&lang=js"
import style0 from "./AddMetricSideSheet.vue?vue&type=style&index=0&id=45376d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45376d38",
  null
  
)

export default component.exports